export default "__VITE_ASSET__yMX5B7YX__"